import { Component, OnDestroy } from '@angular/core';
import { delay, withLatestFrom, takeWhile } from 'rxjs/operators';
import {
  NbMediaBreakpoint,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
  NbDialogService,
} from '@nebular/theme';

import { StateService } from '../../../@core/data/state.service';

import {ApiUtils} from '../../../@core/data/rest/ApiUtils';
import { AuthService } from '../../../auth/auth.service';

import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { FenetreService } from '../../../@core/utils/fenetre-service';
import { SettingService } from '../../../@core/data/rest/setting-service';
import { UserFormComponent } from '../../../pages/setting/settingform/userform.component';
import { User } from '../../../@core/data/model/user';
import { SharedMethods } from '../../../util/sharedMethods-service';


// TODO: move layouts into the framework
@Component({
  selector: 'ngx-sample-layout',
  styleUrls: ['./sample.layout.scss'],
  template: `
    <nb-layout [center]="layout.id === 'center-column'" windowMode [nbSpinner]="settingService.search" nbSpinnerStatus="success" nbSpinnerMessage="{{ settingService.messageSearch }}">
      <nb-layout-header fixed  *ngIf="isPopup && !authservice.isLoginPage"  style="z-index:997">
        <ngx-header [position]="sidebar.id === 'start' ? 'normal': 'inverse'"></ngx-header>
      </nb-layout-header>

      <nb-sidebar *ngIf="isPopup && !authservice.isLoginPage" class="menu-sidebar"
                   tag="menu-sidebar"
                   responsive
                   [end]="sidebar.id === 'end'">
        <nb-sidebar-header *ngIf="currentTheme !== 'corporate'">
          <a href="#" class="btn btn-hero-success main-btn" title="">
          <i class="fa fa-folder-open" ></i> <span> OPTIMUM </span>
            <!--<i class="fa fa-bars"></i>-->
            <!--<span>Menu</span>-->
          </a>
        </nb-sidebar-header>

        <h1 *ngIf=" deviceService.isMobile()  && (authService.token !== null && authService.token !== undefined)">
          <!-- <nb-user  name="Paul Eric" title="Poste" picture="'assets/images/user-icone.png'"></nb-user> -->
          <nb-user  (click)="goToProfile()" name="{{ ( authService.token !== null && authService.token !== undefined ) ? authService.token.user.username : '' }}" title="" picture="'assets/images/user-icone.png'" ></nb-user>

        </h1>

        <h1 *ngIf="deviceService.isMobile()">
          <nb-actions size="medium"
          [class.right]="position === 'normal'"
          [class.left]="position === 'inverse'">

            <!--
            <nb-action
            class="control-item" icon="nb-notifications"
            badgeText="99"
            badgePosition="top left"
            badgeStatus="warning"
            >
            </nb-action>

            <nb-action
            class="control-item" icon="nb-email"
            badgeText="15"
            badgePosition="top left"
            badgeStatus="warning"
            >
            </nb-action>
            -->

            <nb-action class="control-item" *ngIf="authService.token !== null && authService.token !== undefined">
              <nb-search type="rotate-layout" placeholder="Recherche facture..." hint="Entrer le numéro de la facture recherchée."></nb-search>
            </nb-action>

            <nb-action
            class="control-item" icon="fa fa-envelope"
            badgeText=""
            badgePosition="top right"
            badgeStatus="warning"
            (click)="goToChatlink()">
            </nb-action>

            <!-- <nb-action
            class="control-item" icon="fa fa-book"
            badgeText=""
            badgePosition="top right"
            badgeStatus="warning"
            (click)="goToHelplink()">
            </nb-action> -->

            <nb-action *ngIf="authService.token !== null && authService.token !== undefined" class="control-item" icon="nb-power" (click)="goToLogin()">
            </nb-action>


          </nb-actions>
        </h1>

        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="main-content">
        <ng-content select="router-outlet">
        </ng-content>
      </nb-layout-column>

      <nb-layout-column start class="small" *ngIf="layout.id === 'two-column' || layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-column class="small" *ngIf="layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <!-- <nb-layout-footer fixed *ngIf="!authservice.isLoginPage">
        <ngx-footer></ngx-footer>
      </nb-layout-footer> -->

      <!-- <nb-sidebar class="settings-sidebar"
                   tag="settings-sidebar"
                   state="collapsed"
                   fixed
                   [end]="sidebar.id !== 'end'">
        <ngx-theme-settings></ngx-theme-settings>
      </nb-sidebar> -->
    </nb-layout>
  `,
})
export class SampleLayoutComponent implements OnDestroy {

  subMenu: NbMenuItem[] = [
    {
      title: 'PAGE LEVEL MENU',
      group: true,
    },
    {
      title: 'Buttons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/buttons',
    },
    {
      title: 'Grid',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/grid',
    },
    {
      title: 'Icons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/icons',
    },
    {
      title: 'Modals',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/modals',
    },
    {
      title: 'Typography',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/typography',
    },
    {
      title: 'Animated Searches',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/search-fields',
    },
    {
      title: 'Tabs',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/tabs',
    },
  ];
  layout: any = {};
  sidebar: any = {};

  private alive = true;

  currentTheme: string;

  isPopup = true;


  constructor(protected stateService: StateService,
              protected menuService: NbMenuService,
              protected themeService: NbThemeService,
              protected bpService: NbMediaBreakpointsService,
              protected sidebarService: NbSidebarService,
              public dialogService: NbDialogService,
              public sharedMethods: SharedMethods,
              public router: Router,
              public authService: AuthService,
              public apiUtils: ApiUtils,
              public authservice: AuthService,
              public deviceService: DeviceDetectorService,
              private fenetreService: FenetreService,
              public settingService: SettingService) {


    if (this.fenetreService.findnames(window.name) !== null )
    this.isPopup = false;

    this.stateService.onLayoutState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((layout: string) => this.layout = layout);

    this.stateService.onSidebarState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((sidebar: string) => {
        this.sidebar = sidebar;
      });


    const isBp = this.bpService.getByName('is');
    this.menuService.onItemSelect()
      .pipe(
        takeWhile(() => this.alive),
        withLatestFrom(this.themeService.onMediaQueryChange()),
        delay(20),
      )
      .subscribe(([item, [bpFrom, bpTo]]: [any, [NbMediaBreakpoint, NbMediaBreakpoint]]) => {

        if (bpTo.width <= isBp.width) {
          this.sidebarService.collapse('menu-sidebar');
        }
      });

    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.currentTheme = theme.name;
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  goToChatlink() {
    window.open('https://tawk.to/chat/5ca4bc1e6bba460528010e9d/default', '_blank');
  }

  goToHelplink() {
    window.open('https://bessalel.net/aide.php', '_blank');
  }

  goToLogin() {
    // this.menuService.navigateHome();
    this.authService.logout();
    // this.router.navigate(['/pages/login']);
  }

  goToProfile() {

    const user: User  = this.authService.token.user;

      // user.roles = undefined;
      // this.editUser(user, 'update');

      const closeOnBackdropClick = false;
      this.dialogService.open(UserFormComponent, {
        closeOnBackdropClick,
        context: {
          userEdit : user,
        },
      }).onClose.subscribe(data => {

          if ( data !== undefined) {

            this.sharedMethods.toastShow('success', 'Succèss', 'Mise à jour profile');

          }
      });
  }



}
